import React, { useMemo } from 'react';
import { buildLeaveTypeColorMap } from '../leave-dashboard/constants';
import { useMyTeamLeaves } from './useMyTeamLeaves';
import TeamTodayCard from './TeamTodayCard';
import TeamTimelineCard from './TeamTimelineCard';
import { Root, TeamGrid } from './styles';

// Ekibimin İzinleri (spec 2026-10-31-ekibimin-izinleri) — İzin Paneli'nin iki kartı, çağıranın ekibi için. Sayfa
// gövdesinde başlık ve süzgeç şeridi YOK (UI altın kuralı); İzin Paneli'nin 9 ucu çağrılmaz, yalnız ekip uçları.
export default function MyTeamLeavesPage() {
  const team = useMyTeamLeaves();

  // Tür renkleri yalnız türü görünen girdilerden (gizli türler tek nötr renkte).
  const typeColors = useMemo(() => {
    const seen = new Map();
    (team.today.data?.items || []).forEach((item) => {
      if (item.canSeeType && item.leave.leaveVariationId) {
        seen.set(item.leave.leaveVariationId, { id: item.leave.leaveVariationId, name: item.leave.leaveVariationName });
      }
    });
    team.timeline.people.forEach((person) => {
      if (!person.canSeeType) return;
      person.leaves.forEach((entry) => {
        if (entry.leaveVariationId) seen.set(entry.leaveVariationId, { id: entry.leaveVariationId, name: entry.leaveVariationName });
      });
    });
    return buildLeaveTypeColorMap([...seen.values()]);
  }, [team.today.data, team.timeline.people]);

  return (
    <Root>
      <TeamGrid>
        <TeamTodayCard state={team.today} typeColors={typeColors} />
        <TeamTimelineCard
          state={team.timeline}
          monthKey={team.monthKey}
          firstMonth={team.firstMonth}
          lastMonth={team.lastMonth}
          canPrev={team.canPrev}
          canNext={team.canNext}
          goPrev={team.goPrev}
          goNext={team.goNext}
          setMonth={team.setMonth}
          loadMore={team.loadMore}
          typeColors={typeColors}
        />
      </TeamGrid>
    </Root>
  );
}
